import { useEffect, useState } from "react";
import { Share, Smartphone, X } from "lucide-react";

const KEY = "sr-install-tip-dismissed";
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isPhone = () => /iphone|ipod|android.*mobile|mobile.*android/i.test(navigator.userAgent) || window.matchMedia("(max-width: 640px)").matches;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const InstallTip = () => {
  const [show, setShow] = useState(false);
  const [prompt, setPrompt] = useState(null);

  useEffect(() => {
    if (localStorage.getItem(KEY) || isStandalone() || !isPhone()) return;
    setShow(true);
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const close = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  const install = async () => { prompt.prompt(); await prompt.userChoice; close(); };
  if (!show) return null;

  return (
    <div className="fixed bottom-3 inset-x-3 z-50 panel p-4 flex items-start gap-3 border-emerald-500/40 shadow-2xl animate-in fade-in slide-in-from-bottom-4" data-testid="install-tip">
      <img src="/icon-192.png" alt="" className="h-10 w-10 rounded-lg shrink-0" />
      <div className="flex-1 min-w-0 text-sm">
        <div className="font-semibold text-white">Add Strategic Ratings to your home screen</div>
        <div className="text-xs text-slate-400 mt-1" data-testid="install-tip-steps">
          {prompt ? "Open it like an app, full screen, in one tap."
            : isIOS() ? <>In Safari tap <Share className="h-3.5 w-3.5 inline -mt-0.5" /> Share, then <b>Add to Home Screen</b>.</>
            : <>Tap the browser menu <b>⋮</b>, then <b>Add to Home screen</b> or <b>Install app</b>.</>}
        </div>
        {prompt && (
          <button type="button" onClick={install} className="mt-2 inline-flex items-center gap-1.5 rounded bg-emerald-500 px-3 py-1.5 text-xs font-bold text-slate-950 hover:bg-emerald-400 transition-colors" data-testid="install-tip-install">
            <Smartphone className="h-3.5 w-3.5" /> Install app
          </button>
        )}
      </div>
      <button type="button" onClick={close} className="text-slate-500 hover:text-white transition-colors" aria-label="Dismiss" data-testid="install-tip-dismiss">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
